import React from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import Select from "react-select";
import { Box, Grid, TextField, Button } from "@mui/material";
const Encounter = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Encounter</li>
                </ul>
              </div>
            </div>
          </div>
         
              <div className="card row col-sm-12">
                <div className="card-body">
                  <Box component="form" >
                  <div className="form-heading">
                          <h4>Appointment Details</h4>
                        </div>
                    <Grid  spacing={5} container>
                      <Grid sx={12} item xs={6} >
                        <TextField 
                          variant="outlined"
                          required
                          label="Doctor name"
                        />
                      </Grid>
                      <Grid sx={12} item xs={6}>
                        <TextField
                          variant="outlined"
                          required
                          label="Treatment"
                        />
                      </Grid>
                      
                      <Grid sx={12} item xs={6}>
                        <TextField variant="outlined" required label="status" />
                      </Grid>
                      <Grid>
                        <label>
                          From Date <span className="login-danger">*</span>
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            
                            components={["DatePicker"]}
                          >
                            <DatePicker />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid sx={12} item xs={6}>
                        <label>
                          End Date <span className="login-danger">*</span>
                        </label>
                        <LocalizationProvider
                          
                          dateAdapter={AdapterDayjs}
                        >
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                    </Grid>

                    <Button type="submit">Create</Button>
                    <Button type="submit">Cancel</Button>
                  </Box>
                  {/* <form>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Appointment Details</h4>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Doctor Name <span className="login-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Treatment <span className="login-danger">*</span>
                          </label>
                          <input type="text" className="form-control" />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-xl-4">
                        <div className="form-group local-forms ">
                          <label>
                            From Date <span className="login-danger">*</span>
                          </label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                              className="form-control"
                              components={["DatePicker"]}
                            >
                              <DatePicker />
                            </DemoContainer>
                          </LocalizationProvider>
                        </div>
                      </div>
                      <div className="col-12 col-md-3 col-xl-4">
                        <div className="form-group local-forms ">
                          <label>
                            End Date <span className="login-danger">*</span>
                          </label>
                          <LocalizationProvider
                            className="form-control"
                            dateAdapter={AdapterDayjs}
                          >
                            <DemoContainer components={["DatePicker"]}>
                              <DatePicker />
                            </DemoContainer>
                          </LocalizationProvider>
                        </div>
                      </div>
                      

                      <div className="col-12 col-md-3 col-xl-4">
                        <div className="form-group local-forms">
                          <label>
                            Status <span className="login-danger">*</span>
                          </label>
                          <Select
                            defaultValue="ALL"
                            onChange={onchange}
                            options={[
                              {
                                value: "Awaiting Confirmation",
                                label: "Awaiting Confirmation",
                              },
                              {
                                value: "Cancelled By Patient",
                                label: "Cancelled By Patient",
                              },
                              {
                                value: "Cancelled By Provider",
                                label: "Cancelled By Provider",
                              },
                              { value: "Completed", label: "Completed" },
                              { value: "Confirmed", label: "Confirmed" },
                              {
                                value: "Doctor No Show",
                                label: "Doctor No Show",
                              },
                            ]}
                            menuPortalTarget={document.body}
                            id="search-commodity"
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused
                                  ? "none"
                                  : "2px solid rgba(46, 55, 164, 0.1);",
                                boxShadow: state.isFocused
                                  ? "0 0 0 1px #2e37a4"
                                  : "none",
                                "&:hover": {
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1)",
                                },
                                borderRadius: "10px",
                                fontSize: "14px",
                                minHeight: "45px",
                              }),
                              dropdownIndicator: (base, state) => ({
                                ...base,
                                transform: state.selectProps.menuIsOpen
                                  ? "rotate(-180deg)"
                                  : "rotate(0)",
                                transition: "250ms",
                                width: "35px",
                                height: "35px",
                              }),
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2"
                          >
                            Add
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary cancel-form"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form> */}
                </div>
             
          </div>
        </div>
      </div>
    </>
  );
};

export default Encounter;
